module.exports = __webpack_public_path__ + "img/TELENANTES_2020.80fe572b.png";